module.exports = __webpack_public_path__ + "images/six-year-club-3a9da49db92d1eb0ced681e3624bf0d0.png";